import { dataLayerPush, Events } from '@libs/analytics';

export const storeAboutSeoTrackingData = {
    event: Events.VIEW_PAGE_SECTION,
    page_section: 'store details content',
};

export function trackStoreAboutSeoExpand() {
    dataLayerPush({
        ...storeAboutSeoTrackingData,
        event: 'click_page_section',
        selection: 'expand arrow',
    });
}
